//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IconView from "./IconView.vue";

export default {
  name: "AsideCategories",
  components: { IconView },
  props: {
    categories: {
      type: Array
    },
    materialCategories: {
      type: Array
    },
    active: {
      type: String
    },
    forHeader: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    categoriesList() {
      if (this.materialCategories) {
        return this.materialCategories
      }
      if (!this.categories) {
        this.$store.dispatch('art/fetchMaterialCategories')
        return this.$store.state.art.materialCategories
      } else {
        return this.categories.map(x => {
          const res = { ...x }
          delete res.items
          return res.node
        })
      }
    }
  }
}
